



















































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import { roles, features } from "@/config/roles";

import { colorPlayerCount } from "./lib/helpers";

import { getElegantDateString } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";

/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";
import CompositionsTabList from "./components/CompositionsTabList.vue";
import BuffList from "@/components/composition/components/BuffList.vue";

/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Compositions' view page.
 */
@Component({
	components: {
		DataFetcher,
		BuffList,
		GroupCard,
		CompositionsTabList
	}
})
export default class CompositionsViewPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	colorPlayerCount = colorPlayerCount;
	getElegantDateString = getElegantDateString;

	teamUrl = teamUrl;

	/// Props
	@Prop()
	compositionGroup!: GetOneCompositionGroupResponse | null;
	@Prop()
	notifyFetchCompositionGroup!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	activeCompositionIndex = 0;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get canBroadcastToDiscord() {
		return this.hasPermission(roles.MANAGE_DISCORD) && this.hasFeaturePermission(features.DISCORD) && this.currentTeam.discordBroadcastChannelId;
	}

	get activeComposition() {
		if (!this.compositionGroup) {
			return null;
		}
		return this.compositionGroup.compositions[this.activeCompositionIndex];
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchCompositionGroup();
	}

	async fetchCompositionGroup() {
		await this.notifyFetchCompositionGroup();
	}

	async handleDiscordBroadcast(composition: any) {
		this.isLoading = true;
		try {
			await compositionsAPI.broadcastToDiscord(composition.id);
			this.$snackbar.openInfo(this.$t("snackbar.broadcast_discord_success"));
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
